import React, { useCallback, useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Link, useLocation } from 'react-router-dom'
import { useDeepCompareMemo } from 'use-deep-compare'
import { Menu } from 'antd'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import menuData from 'routes/routes'
import { Global } from 'utils/common'

function buildMenus(menuData, parentPath = '', appKey, t) {
  console.log('buildMenus--menuData', menuData)
  return menuData
    .filter(
      ({ noAuths = [], isMenu } = {}) =>
        // isMenu !== false && !noAuths.includes(appKey)
        isMenu != false
    )
    .map(menu => {
      const {
        icon,
        title,
        url,
        children,
        routerConfig: { path }
      } = menu
      const finalPath = `${parentPath}/${url || path}`
      if (children && children.length) {
        const menus = buildMenus(children, finalPath, appKey, t)

        const item = {
          label: <Link to={finalPath}>{t(title)}</Link>,
          key: finalPath,
          icon
        }

        if (menus && menus.length) {
          item.children = menus
          item.label = t(title)
        }

        return item
      }
      console.log('t(title)', t(title))
      return {
        label: <Link to={finalPath}>{t(title)}</Link>,
        key: finalPath,
        icon
      }
    })
}

function useMenus() {
  console.log('useMenus', menuData)
  const { t, i18n } = useTranslation()
  const [menus, setMenus] = useState([])

  const { user } = useSelector(state => state)

  useEffect(() => {
    const { users } = user || {}

    // if (users) {
    //   setMenus(buildMenus(menuData, '', users.app_key, t))
    // }
    setMenus(buildMenus(menuData, '', '', t))
  }, [i18n.language, user])
  return menus
}

function getFlatMenus(arr) {
  return arr.reduce((a, item) => {
    let flatArr = [...a, item]

    if (item.children) {
      flatArr = [...flatArr, ...getFlatMenus(item.children)]
    }
    return flatArr
  }, [])
}

function useMenuKeys(menus) {
  const { pathname } = useLocation()

  const flatMenus = useDeepCompareMemo(() => getFlatMenus(menus), [menus])

  const selectedMenu = flatMenus.find(
    m => pathname.includes(m.key) && typeof m.label === 'object'
  )

  const openKeys = flatMenus.find(m => `/${pathname.split('/')[1]}` === m.key)

  return {
    selectedKeys: selectedMenu ? [selectedMenu.key] : [],
    openKeys: openKeys ? [openKeys.key] : []
  }
}

function Nav(props) {
  const { mode, theme, collapsed } = props
  const menus = useMenus()
  const { selectedKeys, openKeys } = useMenuKeys(menus)
  const [finalOpenKeys, setFinalOpenKeys] = useState([
    '/picture-processing',
    '/smart-picture'
  ])
  const { pathname } = useLocation()
  const ref = useRef({
    openKeys: [],
    collapsed: false
  })

  useEffect(() => {
    let temp = []

    if (Global.layoutDirection === 'ver' || collapsed) {
      ref.collapsed = collapsed

      temp = []

      if (finalOpenKeys.length) {
        ref.openKeys = finalOpenKeys
      }
    } else {
      if (finalOpenKeys.length) {
        temp = finalOpenKeys

        if (openKeys.length && !finalOpenKeys.includes(openKeys[0])) {
          temp = finalOpenKeys.concat(openKeys)
        }
      } else {
        // 点击打开收缩按钮
        if (ref.collapsed && !collapsed) {
          ref.collapsed = false

          if (ref.openKeys.length) {
            temp = ref.openKeys
          }
        } else {
          temp = openKeys
        }
      }
    }
    console.log('setFinalOpenKeys~~', temp)
    setFinalOpenKeys(temp)
  }, [collapsed, pathname])

  const onOpenChange = useCallback(keys => {
    console.log('onOpenChange', keys)
    setFinalOpenKeys(keys)
  }, [])

  console.log('Menu render...', menus)
  return (
    <Menu
      mode={mode}
      theme={theme}
      items={menus}
      selectedKeys={selectedKeys}
      openKeys={finalOpenKeys}
      onOpenChange={onOpenChange}
      style={{ border: 'none' }}
    />
  )
}

export default Nav

Nav.propTypes = {
  mode: PropTypes.string,
  theme: PropTypes.string
}

Nav.defaultProps = {
  mode: 'inline',
  theme: 'light'
}
